export const STORE_DOCUMENT_VIEW = 'documentViewUI';
export type STORE_DOCUMENT_VIEW = typeof STORE_DOCUMENT_VIEW;
